module.exports = __webpack_public_path__ + "img/GR121.7d463058.png";